module.exports = __webpack_public_path__ + "img/back-anroid.181f55b9.png";